import { v4 as uuidv4 } from 'uuid';

export class Score {
  constructor () {
    this.id = uuidv4(),
    this.match = "",
    this.home = undefined,
    this.away = undefined
  }
}